import React from 'react'
import ReceviedCardListContainer from '../ReceviedCardListContainer.jsx'
import { useSelector } from 'react-redux'

function ReceviedList({ title }) {
    const { user } = useSelector((state) => state.user);

    return (
        <ReceviedCardListContainer user={user} matches={user.pendingInvites} title={title} />
    )
}

export default ReceviedList